import { DesignSystem } from "../design-system.js";
import { WizardPanel } from "./wizard-panel.js";
import { styles } from "./wizard-panel.styles.js";
import { template } from "./wizard-panel.template.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-wizard-panel>
 */
export const definition = WizardPanel.compose({
    name: `${DesignSystem.prefix}-wizard-panel`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=wizard-panel.definition.js.map